const HEADER_OFFSET = 80;

// Scrollea a una seccion por id compensando la altura del header fijo
export function scrollToSection(sectionId) {
  const element = document.getElementById(sectionId);
  if (!element) return;

  const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
  window.scrollTo({
    top: elementPosition - HEADER_OFFSET,
    behavior: 'smooth'
  });
}
